import { useState } from "react";
import { docParsing } from "@/api/docParsing.service";
import type { SubmissionDocument } from "../../utils/originalSubmissionState";
import styles from "./OriginalSubmissionTab.module.css";

/** Downloads the submission file the result was parsed from; renders nothing when there is none. */
export function DocumentLink({ document }: { document: SubmissionDocument | null }) {
  const [failed, setFailed] = useState(false);
  if (!document) return null;

  async function download(file: SubmissionDocument) {
    setFailed(false);
    try {
      await docParsing.downloadParseResultDocument(file.docParseResultId, file.fileName);
    } catch {
      setFailed(true);
    }
  }

  return (
    <>
      <button
        type="button"
        className={`${styles.link} ${styles.linkButton}`}
        onClick={() => download(document)}
      >
        Download original document
      </button>
      {failed && (
        <p role="alert" className={styles.downloadError}>
          The document could not be downloaded. Try again shortly.
        </p>
      )}
    </>
  );
}
